import { PB_TYPE_TEXTBLOCK } from './constants';
import { ELEMENT } from '../../constants';
const getComponentsToInsertByType = (items, insertionType) => {
  if (!items || !items.length) return [false, []];
  if (insertionType === ELEMENT) {
    const componentsToInject = items.filter(({
      settings: {
        insertionType: insertionTypeSetting,
        startingPoint,
        repeatEvery,
        maxRepetitions
      }
    }) => insertionTypeSetting === insertionType && startingPoint !== 0 && repeatEvery !== 0 && maxRepetitions !== 0);
    return [!!componentsToInject.length, componentsToInject];
  }
  if (insertionType === PB_TYPE_TEXTBLOCK) {
    const textBlockBanners = items.filter(({
      settings: {
        insertionType: insertionTypeSetting
      }
    }) => insertionTypeSetting === PB_TYPE_TEXTBLOCK);
    return [!!textBlockBanners.length, textBlockBanners];
  }
  return [false, []];
};
export default getComponentsToInsertByType;
//# sourceMappingURL=get-components-to-insert-by-type.js.map